module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Knife2-a484d74c8dae820748ec5cde40b64e17.svg";